import React from 'react';
import '../less/itemDetails.less';
import {Link, Popup} from '@ab/components';
import Percent from '../views/percent.c';
import {getCurrencySymbol} from '../../../constants/currency';

export default function template() {
    let converting = null,
        originalAmount = null,
        country = null,
        hint = null,
        fee = null,
        debitBalance = null,
        calculations = null;
    const {percent} = this.state,
        {model, settings, card} = this.props;
        const showStatementsPercent = model.flags.credit_percentage_decryption && model.category.id == '100000000000895'

    if (this.hadConverting(model)) {
        converting = (
            <div className="control">
                <div className="control__label">
                    {this.l10n('STATEMENTS_DETAILS_LABEL_CONVERTING')}
                </div>
                :&nbsp;
                <div>{this.exchangeRate(model).toString()}</div>
            </div>
        );

        originalAmount = (
            <div className="control">
                <div className="control__label">
                    {this.l10n('STATEMENTS_DETAILS_LABEL_ORIGINAL')}
                </div>
                :&nbsp;
                <div>{model.amount_original.value.toString()}</div>
                &nbsp;
                <div>{getCurrencySymbol(parseInt(model.amount_original.currency))}</div>
            </div>
        );
    }

    if (model.country) {
        country = (
            <div className="control">
                <div className="control__label">
                    {this.l10n('STATEMENTS_DETAILS_LABEL_COUNTRY')}
                </div>
                :&nbsp;
                <div>{model.country.name}</div>
            </div>
        );
    }

    // if (model.get('showHint')) {
    //     hint = (
    //         <div className="control">
    //             <div dangerouslySetInnerHTML={{__html: model.hint()}} />
    //         </div>
    //     );
    // }

    if (model.fee?.value > 0) {
        fee = (
            <div className="control">
                <div className="control__label">{this.l10n('STATEMENTS_DETAILS_LABEL_FEE')}</div>
                :&nbsp;
                <div>{model.fee.value.toString()}</div>
                &nbsp;
                <div>{getCurrencySymbol(parseInt(model.fee.currency))}</div>
            </div>
        );
    }

    if (percent) {
        calculations = (
            <Popup onClose={this.toggleCalculations}>
                <Percent cardId={card.id} date={model.date} />
            </Popup>
        );
    }

    if (model.balance.leger < 0) {
        debitBalance = (
            <div className="control">
                <div className="control__label">{this.l10n('STATEMENTS_DETAILS_LABEL_DEBIT')}</div>
                :&nbsp;
                <div className="control__value debit">
                    {model.balance.leger.toString()}{' '}
                    {getCurrencySymbol(parseInt(model.amount_original.currency))}
                </div>
            </div>
        );
    }

    return (
        <>
            {calculations}
            <div className="module-statements-item-details">
                {converting}
                {originalAmount}
                {fee}
                {country}
                {debitBalance}
                {/* <div className="control">*/}
                {/*    <div className="control__label">*/}
                {/*        {this.l10n('STATEMENTS_DETAILS_LABEL_CARD')}*/}
                {/*    </div>*/}
                {/*    :&nbsp;*/}
                {/*    <div>{model.card?.name}</div>*/}
                {/*    &nbsp;*/}
                {/* </div>*/}
                <div className="control">
                    <div className="control__label">
                        {this.l10n('STATEMENTS_DETAILS_LABEL_DESCRIPTION')}
                    </div>
                    :&nbsp;
                    <div>{model.purpose}</div>
                </div>
                {model.type === 'DEBIT' && model.hint_attributes && model.hint_attributes['D0'] ? (
                    <div className="control">
                        <div className="control__label">
                            {this.l10n('STATEMENTS_DETAILS_LABEL_HINT_ATTRIBUTES_D0')}
                        </div>
                        :&nbsp;
                        <div>{model.hint_attributes['D0']}</div>
                    </div>
                ) : null}

                {model.type === 'DEBIT' && model.hasOwnProperty('state') ? (
                    <div className="control">
                        <div className="control__label">
                            {this.l10n('STATEMENTS_DETAILS_LABEL_STATE_OPERATION')}
                        </div>
                        :&nbsp;
                        <div>{Number(model.state) ? 'Списана' : 'Заблокована'}</div>
                    </div>
                ) : null}

                {model.flags.receipt_available ? (
                    <button onClick={() => this.printInvoice(model)} className="invoice-button">
                        {this.l10n('STATEMENTS_INVOICE')}
                    </button>
                ) : null}
                {showStatementsPercent ? (
                    <button
                        onClick={() =>
                            this.handleCardSetting({
                                date_from: model.date,
                                hash_pan: card.attributes.hashPan,
                            })
                        }
                        className="invoice-button"
                    >
                        {this.l10n('STATEMENTS_PERCENT')}
                    </button>
                ) : null}
                {hint}
                {this.isPercentsByCredit(settings) ? (
                    <Link inText onClick={this.toggleCalculations}>
                        {this.l10n('STATEMENTS_DETAILS_BTN_PERCENT_CALC')}
                    </Link>
                ) : null}
            </div>
            {this.state.isShowErrorModal ? (
                <div className="modal-wrapper">
                    <div className="modal">
                        <div className="modal-header">
                            <h4></h4>
                            <span onClick={() => this.setState({isShowErrorModal: false})}>
                                &times;
                            </span>
                        </div>
                        <div className="modal-body">
                            <h3 className="color-red">Виникла помилка, повторіть спробу</h3>
                        </div>
                        <div className="modal-footer color-red">
                            <button onClick={() => this.setState({isShowErrorModal: false})}>
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}
            {this.state.isShowModal ? (
                <div className="modal-wrapper">
                    <div className="modal">
                        <div className="modal-header">
                            <h4>{this.l10n('STATEMENTS_INPUT_EMAIL')}</h4>
                            <span onClick={() => this.setState({isShowModal: false})}>&times;</span>
                        </div>
                        <div className="modal-body">
                            <input
                                placeholder={this.l10n('STATEMENTS_INPUT_EMAIL')}
                                value={this.state.emailValue}
                                onChange={this.handleChangeEmail}
                                type="text"
                            />
                        </div>
                        <div className="modal-footer">
                            <button
                                onClick={() => this.sendToEmail(model)}
                                disabled={this.state.isDisabledEmail}
                                className={this.state.isDisabledEmail ? 'disabled' : ''}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}
            <div className={`snackbar ${this.state.showToast ? 'show' : ''}`}>
                {this.l10n('STATEMENTS_OUTPUT_EMAIL')}
            </div>
        </>
    );
}
